import React from 'react'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import './HoverReveal.module.scss'

/**
 * Class to put on the hover group — the ancestor whose hover/focus reveals the action, typically a
 * table row (e.g. react-bootstrap-table's `rowClasses`). Children wrapped in <HoverReveal> stay
 * hidden until an element carrying this class is hovered or contains keyboard focus.
 */
export const HOVER_REVEAL_GROUP = 'Uic-HoverReveal-group'

const propTypes = {
  children: PropTypes.node,
  /** Extra classes on the wrapper. */
  className: PropTypes.string,
}

/**
 * Wraps a row-level action (copy, edit, …) so a column of them stays uncluttered: the action is
 * hidden until its hover group (an ancestor carrying `HOVER_REVEAL_GROUP`) is hovered or receives
 * keyboard focus — and also when the action itself is hovered/focused. It stays laid out (opacity,
 * not display) and focusable, so rows never jump and keyboard users can still reach it.
 */
function HoverReveal({ children = null, className = '' }) {
  return <span className={clsx('Uic-HoverReveal-item', className)}>{children}</span>
}

HoverReveal.propTypes = propTypes

export default HoverReveal
